<template>
	<page>
		<module>
			<view-list work-type="42" ref="view" selector :view-config="auth('b_quality_output_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="工单编号">
							<c-input name="work_code"></c-input>
						</m-search-item>
						<m-search-item label="生产人员">
							<c-select name="output_user_ids" async multiple @search="searchOutputUser" ></c-select>
						</m-search-item>
						<m-search-item label="工序编号">
							<c-input name="process_code"></c-input>
						</m-search-item>
						<m-search-item label="工序名称">
							<c-input name="process_name"></c-input>
						</m-search-item>
						<m-search-item label="产品编号">
							<c-input name="product_code"></c-input>
						</m-search-item>
						<m-search-item label="产品名称">
							<c-input name="product_name"></c-input>
						</m-search-item>
						<m-search-item label="规格名称">
							<c-input name="product_spec"></c-input>
						</m-search-item>
						<m-search-item label="检验方式">
							<c-select name="test_modes" :options="testModeQualityDic" multiple ></c-select>
						</m-search-item>
						<m-search-item label="质检状态">
							<c-select name="test_states" :options="testStateQualityDic" multiple ></c-select>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_quality_output_export')" v-lock="lock('b_quality_output_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_quality_output_export')" v-lock="lock('b_quality_output_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>

				<template #batchOperate="{data}">
					<c-button v-if="auth('b_quality_output_export')" v-lock="lock('b_quality_output_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_quality_output_export')" v-lock="lock('b_quality_output_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_quality_output_print')" v-lock="lock('b_quality_output_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
					<c-button v-if="auth('b_quality_output_test')" v-lock="lock('b_quality_output_test')" prepend-icon="tf-approve" color="main" @click="batchTestPass(data)">批量质检通过</c-button>
				</template>

				<!--报工类型-->
				<template #output_type="{data}">
					<c-state dict="outputTypeDic" :value="data.output_type"></c-state>
				</template>

				<!--报工良品率-->
				<template #fine_ratio="{data}">
					{{data.fine_ratio}}%
				</template>
				
				<!--检验方式-->
				<template #test_mode="{data}">
					<c-state dict="testModeDic" :value="data.test_mode"></c-state>
				</template>
				
				<!--检验状态-->
				<template #test_state="{data}">
					<c-state dict="testStateDic" :value="data.test_state"></c-state>
				</template>
				
				<!--质检人-->
				<template #test_user_realname="{data}">
					<span v-if="data.test_state == 3">{{data.test_user_realname}}</span>
					<span v-else>-</span>
				</template>
				
				<!--质检时间-->
				<template #test_date="{data}">
					<span v-if="data.test_state == 3">{{data.test_date}}</span>
					<span v-else>-</span>
				</template>
				
				<!--质检数-->
				<template #test_count="{data}">
					<span v-if="data.test_state == 3">{{data.test_count}}</span>
					<span v-else>-</span>
				</template>
				<!--质检数-合计行-->
				<template #test_count_summed="{total}">
					{{total}}
				</template>
				
				<!--质检合格数-->
				<template #test_fine_count="{data}">
					<span v-if="data.test_state == 3">{{data.test_fine_count}}</span>
					<span v-else>-</span>
				</template>
				<!--质检合格数-合计行-->
				<template #test_fine_count_summed="{total}">
					{{total}}
				</template>
				
				<!--质检不合格数-->
				<template #test_defects_count="{data}">
					<span v-if="data.test_state == 3">{{data.test_defects_count}}</span>
					<span v-else>-</span>
				</template>
				<!--质检不合格数-合计行-->
				<template #test_defects_count_summed="{total}">
					{{total}}
				</template>
				
				<!--质检良品率-->
				<template #test_fine_ratio="{data}">
					<span v-if="data.test_state == 3">{{data.test_fine_ratio}}%</span>
					<span v-else>-</span>
				</template>

				<!--产品来源-->
				<template #product_source="{data}">
					<c-state dict="productSourceName" :value="data.product_source"></c-state>
				</template>
				
				<!--工单编号-->
				<template v-if="auth('m_work')" #work_code="{data}">
					<c-link @click="globalDialog('workDetail', {props: {id: data.work_id}})">{{data.work_code}}</c-link>
				</template>
				
				<!--工序编号-->
				<template v-if="auth('m_task')" #process_code="{data}">
					<c-link @click="globalDialog('taskDetail', {props: {id: data.task_id}})">{{data.process_code}}</c-link>
				</template>
				
				<!--工序名称-->
				<template v-if="auth('m_task')" #process_name="{data}">
					<c-link @click="globalDialog('taskDetail', {props: {id: data.task_id}})">{{data.process_name}}</c-link>
				</template>
				
				<c-table-column
					type="button"
					label="操作"
					width="225"
					button-limit="4"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_quality_output_test')" :disabled="!(data.test_state == 2)" @click="testOutput(data)">质检</c-table-button>
						<c-table-button v-if="auth('b_quality_output_revoke_test')" v-lock="lock('b_quality_output_revoke_test')" :disabled="!(data.test_state == 3)" icon="tf-revoke" @click="revokeTest(data)">撤回</c-table-button>
						<c-table-button icon="tf-detail" @click="globalDialog('outputDetail', {props: {id: data.id}})">查看</c-table-button>
						<c-table-button v-if="auth('b_quality_output_print')" v-lock="lock('b_quality_output_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
					</template>
				</c-table-column>
			</view-list>
			
			<!--报工质检信息弹窗-->
			<quality-output-test ref="qualityOutputTest" @resolve="$refs.view.update()"></quality-output-test>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import qualityOutputTest from "@/pages/quality/quality_output_test.vue"
	
	export default {
		components: {
			qualityOutputTest
		},

		data() {
			return {
			}
		},
		
		computed: {
			// 获取dictName选项数据
			...mapState(['userInfo', 'outputTypeDic', 'testModeQualityDic', 'testStateQualityDic'])
		},
		
		mounted() {
		    this.$bus.$on('output.list.update', data => {
		        // 刷新列表
		        this.$refs.view.update();
		    });
		},
		
		beforeDestroy() {
			this.$bus.$off('output.list.update');
		},
		
		methods: {
			/******报工质检***/
			testOutput(data) {
				this.$refs.qualityOutputTest.open(data);
			},
			
			/****批量质检通过**/
			batchTestPass(selectData){
				//仅未质检的报工允许质检通过
				if(selectData.some(item => item.test_state != 2)){
					this.$message({
						message: '所选数据中存在已质检的报工，请重新选择',
						type: 'warn'
					});
					return;
				}
				
				this.$confirm({
					title: '批量质检通过确认',
					message:'确认批量质检通过' + selectData.length + '条报工记录吗？通过后合格数记为报工良品数，不合格数记为0',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/quality/output/batchTestPass',
							data: {ids: selectData.map(item => item.id)},
							loading: true,
							success: data => {
								let Mtype = 'success';
								let message = data.success_count + '条报工记录质检通过成功';
								if(data.fail_count > 0 && data.success_count > 0){
									Mtype = 'warn';
									message += '，失败'+data.fail_count+'条';
								}else if(data.fail_count > 0 && data.success_count == 0){
									Mtype = 'fail';
									message = data.fail_count + '条报工记录质检通过失败';
								}
								this.$message({
									message: message,  // 提示内容,
									type: Mtype
								});
								//刷新
								this.$refs.view.refresh();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
					
			/******撤回***/
			revokeTest(data) {
				this.$confirm({
					message: '撤回后将清除质检数据，是否确认撤回？',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/quality/output/revokeTest',
							data: { id: data.id },
							loading: true,
							success: res => {
								this.$message({ message: '撤回成功', type: 'success' });
								this.$refs.view.update();
							}
						});
					},
					cancel: () => {}
				});
			},
			
			/*******搜索【员工】下拉框信息*****************/
			searchOutputUser(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'SYSUSER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
		}
	}
</script>

<style lang="stylus" scoped>
</style>